import { HierarchyNode, HierarchyPointNode, stratify, tree } from "d3-hierarchy";
import { useMemo } from "react";
import { createTopicNodeToReturn } from "../nodes/topic-node/topic-node.helper";
import { TypeTopicNode } from "../nodes/topic-node/topic-node.model";
import { Instance, InstanceMap } from "../triggers/semantic-dive/semantic-dive";

const layoutNodes = true;
const treeWidth = 700;
const treeHeight = 365;

function getLayerPosition(
  pointNode: HierarchyNode<Instance> | HierarchyPointNode<Instance>
) {
  if (pointNode.data.topicNode.id === 'topic-root') {
    return { x: 0, y: -treeHeight };
  }
  return isHierarchyPointNode(pointNode) ?
    { x: pointNode.x, y: pointNode.y-treeHeight } :
    { x: pointNode.data.position.x, y: pointNode.data.position.y-treeHeight };
}

function isHierarchyPointNode(
  pointNode: HierarchyNode<Instance> | HierarchyPointNode<Instance>
): pointNode is HierarchyPointNode<Instance> {
  return (
    typeof (pointNode as HierarchyPointNode<Instance>).x === 'number' &&
    typeof (pointNode as HierarchyPointNode<Instance>).y === 'number'
  );
}

export default function useInstanceHierarchy(
  instances: Instance[],
): Instance[] {
  return useMemo(() => {

    const rootTopic: TypeTopicNode = createTopicNodeToReturn('Root', '',
    {
      x: window.innerWidth/2 + 700,
      y: window.innerHeight/2,
    }, [], false);

    rootTopic.id = 'topic-root';

    const rootInstance: Instance = {
      parentId: '',
      topicNode: rootTopic,
      jsonObject: {
        nodes: [rootTopic],
        edges: [],
        viewport: { x: 0, y: 0, zoom: 1 }
      },
      level: -1,
      canvasImageURL: '',
      position: { x: 0, y: -280 },
    }

    // All empty root instances now point to root topic
    instances.forEach(instance => {
      instance.parentId = instance.parentId || rootTopic.id;
    })

    const hierarchy = stratify<Instance>()
      .id((d) => d.topicNode.id)
      .parentId((d: Instance) => d.parentId)([rootInstance, ...instances]);

    const layout = tree<Instance>()
      .nodeSize([treeWidth, treeHeight])
      .separation((d) => 1/Math.pow(d.data.level < 0 ? 1 : d.data.level+1, 1/3));

    const root = layoutNodes ? layout(hierarchy) : hierarchy;

    console.log('ready to update hierarchy');

    return [
      ...root.descendants().map((d) => ({
        ...d.data,
        position: getLayerPosition(d),
      })),
    ];
  }, [instances])
}